<template>
  <header>
    <div class="logo-wrapper">
      <div class="container">
        <a href="http://www.gkpge.pl/">
          <img src="../assets/images/logo.png" alt="PGE - Zapewniamy energię"/>
        </a>
      </div>
    </div>
    <div class="title-wrapper">
      <div class="container">
        <h1>Doładuj swój licznik</h1>
        <p>
          Doładuj swój licznik przedpłatowy bez wychodzenia z domu.<br/>
          <span>Jak? To łatwe.</span> Wypełnij formularz, a otrzymasz kod doładowania.
        </p>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader'
}
</script>
